// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_3qmOA","description":"_1ASHh","zeroDeposit":"_1x8lR","bottomBorder":"_36RhD","stepsContainer":"gg29d","steps":"_1cZz8"};